import { Drawer, Menu } from "antd";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import generateMenus, { sideMenuItensIconsStyle } from "../../components/menu/Menus"
import logo from '../../assets/logo.png'
import { useContext } from "react";
import styles from "../../services/styles";
import { LoginOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import GeneralContext from "../../context/GeneralContext/GeneralContext";
import { displayMessage } from "../../services/helper";
import Cookies from "js-cookie";

const {  bc1 } = styles


export default function DrawerMenu() {
  const {setLoggedUser, windowHeight, user, selectedLanguage} = useContext(GeneralContext)

  const [collapsed, setCollapsed] = useState(false);
  const [menuDrawerVisible, setMenuDrawerVisible] = useState(false);
  const [menu_selected_keys, setMenuSelectedKeys] = useState([])
  const [menu_selected_title, setMenuSelectedTitle] = useState([])
  const [currentMenu, setCurrentMenu] = useState(generateMenus())

        useEffect(() => {
            const newMenus = generateMenus()
            setCurrentMenu(newMenus)
        }, [selectedLanguage])

  const handleOnClickLogout = () => {
    setLoggedUser(false)
  }

  const handleOnClickItemMenu = e => {
    setMenuSelectedKeys([e.key])
    setMenuSelectedTitle([e.item.props.title])
    onCloseDrawer()
  }

  const onCloseDrawer = () => setMenuDrawerVisible(false)
  const onOpenDrawer = () => setMenuDrawerVisible(true)

  const menuOptions = 
  user?.user_type_formatted?.id == 2 ? currentMenu.adminSideMenuItens 
  : user?.user_type_formatted?.id == 1 ? currentMenu.monitorSideMenuItens
  : user?.user_type_formatted?.id == 3 ? currentMenu.dentistSideMenuItens
  : []

  const listMobileMenuItens = [
    ...menuOptions.map(
      item => {
        return {
          key: item.key,
          label: (
            <Link
              style={{
                color: menu_selected_keys && menu_selected_keys[0] == item.key ? '#1b3663' : 'white',
                fontWeight: menu_selected_keys && menu_selected_keys[0] == item.key ? 'bold' : 'normal',
                fontSize: 16,
                display: 'flex',
                alignItems: 'center',
                gap: 5
              }}
              to={item.key}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                {item.icon}

                <span>{item.title}</span>
              </div>
            </Link>
          )
        }
      }
    ),

    ...currentMenu.topMenuItens.map(
      item => {
        return {
          key: item.key,
          label: (
            <Link
              style={{
                color: menu_selected_keys && menu_selected_keys[0] == item.key ? '#1b3663' : 'whitesmoke',
                fontWeight: menu_selected_keys && menu_selected_keys[0] == item.key ? 'bold' : 'normal',
                fontSize: 16,
              }}
              to={item.key}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                {item.icon}

                <span>{item.title}</span>
              </div>
            </Link>
          )
        }
      }
    ),

    {
      key: '/logout',
      label: (
        <Link
          style={{
            color: 'white',
            fontSize: 16,
            fontWeight: 'normal'
          }}
          to={'/logout'}
          onClick={handleOnClickLogout}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <LoginOutlined style={sideMenuItensIconsStyle} />

            <span>{displayMessage('LOGOUT')}</span>
          </div>
        </Link>
      )
    }
  ]

  return (
    <div>
      <MenuUnfoldOutlined
        style={{ position: 'absolute', top: 20, left: 10, fontSize: 24, marginLeft: 15, color: '#1b3663', cursor: 'pointer' }}
        onClick={onOpenDrawer}
      />
      <Drawer
        title={<TitleDrawer />}
        onClose={onCloseDrawer}
        placement="left"
        visible={menuDrawerVisible}
      >
        <Menu
          mode="inline"
          defaultOpenKeys={['menu']}
          style={{ height: '100%', height: collapsed ? windowHeight - 71 : windowHeight - 112, borderRight: 0, background: bc1, paddingTop: 10 }}
          items={listMobileMenuItens}
          onSelect={handleOnClickItemMenu}
        />
      </Drawer>
    </div>

  )
}

const TitleDrawer = () => (
  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', marginBottom: 0 }}>
    <p style={{ marginRight: 3, paddingTop: 10 }}>{displayMessage('MENU')}</p>
    <img
      width={'10%'}
      style={{ marginLeft: '12px', margin: 0, padding: 0 }}
      src={logo}
    />
  </div>
)
